const API_URL = process.env.REACT_APP_API_URL;

export const retrieveOrganisationLevels = async (token) => {

	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	headers.append("Authorization", "Bearer " + token)

	let method = "GET";

	let requestOptions = {
		method: method,
		headers: headers,
	};

	const response = await fetch(API_URL + "/get-organisation-levels", requestOptions);

	if (!response.ok) {
		throw new Error("Failed to fetch data");
	}

	return response.json();
}

export const retrieveHiddenCosts = async (level, token, filtersRef, startDate, endDate) => {
	if (token === "" || filtersRef === undefined || startDate === null || endDate === null) return;

	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	headers.append("Authorization", "Bearer " + token)

	let method = "POST";

	let reqFilters = [];

	const requestBody = {
		filters: reqFilters,
		start_date: startDate.format("YYYY-MM-DD"),
		end_date: endDate.format("YYYY-MM-DD"),
	};

	let requestOptions = {
		body: JSON.stringify(requestBody),
		method: method,
		headers: headers,
	};

	const response = await fetch(API_URL + "/get-hidden-costs?level=" + level, requestOptions);

	if (!response.ok) {
		throw new Error("Failed to fetch data");
	}

	return response.json();
}

export const retrieveCostPerProject = async (level, token, filtersRef, startDate, endDate) => {
	if (token === "" || filtersRef === undefined || startDate === null || endDate === null) return;

	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	headers.append("Authorization", "Bearer " + token)

	let method = "POST";

	let reqFilters = [];
	let reqMeasures = [];
	let reqGrouping = [];

	filtersRef.current.forEach((filter) => {
		reqFilters.push({
			field: filter.category,
			operator: "=",
			values: filter.selectedValues,
		});
	});

	reqFilters.push({field: "level", operator: "=", values: [level] });
	reqMeasures.push({name: "cost", formula: "sum(field.direct_cost + field.direct_allocated_cost)"});
	reqGrouping.push("project_name");

	const requestBody = {
		measures: reqMeasures,
		filters: reqFilters,
		grouping: reqGrouping,
		start_date: startDate.format("YYYY-MM-DD"),
		end_date: endDate.format("YYYY-MM-DD"),
		group_by_date: false,
	};

	let requestOptions = {
		body: JSON.stringify(requestBody),
		method: method,
		headers: headers,
	};

	const response = await fetch(API_URL + "/get-cloud-cost-aggregated", requestOptions);

	if (!response.ok) {
		throw new Error("Failed to fetch data");
	}

	return response.json();
}

export const retrieveCostPerOrganisation = async (level, token, filtersRef, startDate, endDate) => {
	if (token === "" || filtersRef === undefined || startDate === null || endDate === null) return;

	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	headers.append("Authorization", "Bearer " + token)

	let method = "POST";

	let reqFilters = [];
	let reqMeasures = [];
	let reqGrouping = [];

	filtersRef.current.forEach((filter) => {
		reqFilters.push({
			field: filter.category,
			operator: "=",
			values: filter.selectedValues,
		});
	});

	reqFilters.push({field: "level", operator: "=", values: [level] });
	reqMeasures.push({name: "cost", formula: "sum(field.direct_cost + field.direct_allocated_cost)"});
	reqGrouping.push("organisation_name");

	const requestBody = {
		measures: reqMeasures,
		filters: reqFilters,
		grouping: reqGrouping,
		start_date: startDate.format("YYYY-MM-DD"),
		end_date: endDate.format("YYYY-MM-DD"),
		group_by_date: false,
	};

	let requestOptions = {
		body: JSON.stringify(requestBody),
		method: method,
		headers: headers,
	};

	const response = await fetch(API_URL + "/get-cloud-cost-aggregated", requestOptions);

	if (!response.ok) {
		throw new Error("Failed to fetch data");
	}

	return response.json();
}


export const retrieveCostPerCostComponentGroup = async (level, token, filtersRef, startDate, endDate) => {
	if (token === "" || filtersRef === undefined || startDate === null || endDate === null) return;

	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	headers.append("Authorization", "Bearer " + token)

	let method = "POST";

	let reqFilters = [];
	let reqMeasures = [];
	let reqGrouping = [];

	filtersRef.current.forEach((filter) => {
		reqFilters.push({
			field: filter.category,
			operator: "=",
			values: filter.selectedValues,
		});
	});

	reqFilters.push({field: "level", operator: "=", values: [level] });
	reqMeasures.push({name: "cost", formula: "sum(field.direct_cost + field.direct_allocated_cost)"});
	reqGrouping.push("cost_resource_cluster");

	const requestBody = {
		measures: reqMeasures,
		filters: reqFilters,
		grouping: reqGrouping,
		start_date: startDate.format("YYYY-MM-DD"),
		end_date: endDate.format("YYYY-MM-DD"),
		group_by_date: false,
	};

	let requestOptions = {
		body: JSON.stringify(requestBody),
		method: method,
		headers: headers,
	};

	const response = await fetch(API_URL + "/get-cloud-cost-aggregated", requestOptions);

	if (!response.ok) {
		throw new Error("Failed to fetch data");
	}

	return response.json();
}

export const retrieveCostPerProjectPerMonth = async (level, token, filtersRef, startDate, endDate) => {
	if (token === "" || filtersRef === undefined || startDate === null || endDate === null) return;

	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	headers.append("Authorization", "Bearer " + token)

	let method = "POST";

	let reqFilters = [];
	let reqMeasures = [];
	let reqGrouping = [];

	filtersRef.current.forEach((filter) => {
		reqFilters.push({
			field: filter.category,
			operator: "=",
			values: filter.selectedValues,
		});
	});

	reqFilters.push({field: "level", operator: "=", values: [level] });
	reqMeasures.push({name: "measure", formula: "sum(field.direct_cost + field.direct_allocated_cost)"});
	reqGrouping.push("project_name");

	const requestBody = {
		measures: reqMeasures,
		filters: reqFilters,
		grouping: reqGrouping,
		start_date: startDate.format("YYYY-MM-DD"),
		end_date: endDate.format("YYYY-MM-DD"),
		group_by_date: true,
		add_grouped_results: true,
		date_granularity: "month",
	};

	let requestOptions = {
		body: JSON.stringify(requestBody),
		method: method,
		headers: headers,
	};

	const response = await fetch(API_URL + "/get-cloud-cost", requestOptions);

	if (!response.ok) {
		throw new Error("Failed to fetch data");
	}

	return response.json();
}

export const retrieveCostPerOrganisationPerMonth = async (level, token, filtersRef, startDate, endDate) => {
	if (token === "" || filtersRef === undefined || startDate === null || endDate === null) return;

	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	headers.append("Authorization", "Bearer " + token)

	let method = "POST";

	let reqFilters = [];
	let reqMeasures = [];
	let reqGrouping = [];

	filtersRef.current.forEach((filter) => {
		reqFilters.push({
			field: filter.category,
			operator: "=",
			values: filter.selectedValues,
		});
	});

	reqFilters.push({field: "level", operator: "=", values: [level] });
	reqMeasures.push({name: "measure", formula: "sum(field.direct_cost + field.direct_allocated_cost)" });
	reqGrouping.push("organisation_name");

	const requestBody = {
		measures: reqMeasures,
		filters: reqFilters,
		grouping: reqGrouping,
		start_date: startDate.format("YYYY-MM-DD"),
		end_date: endDate.format("YYYY-MM-DD"),
		group_by_date: true,
		add_grouped_results: true,
		date_granularity: "month",
	};

	let requestOptions = {
		body: JSON.stringify(requestBody),
		method: method,
		headers: headers,
	};

	const response = await fetch(API_URL + "/get-cloud-cost", requestOptions);

	if (!response.ok) {
		throw new Error("Failed to fetch data");
	}

	return response.json();
}

export const retrieveCostPerCostComponentGroupPerMonth = async (level, token, filtersRef, startDate, endDate) => {
	if (token === "" || filtersRef === undefined || startDate === null || endDate === null) return;

	const headers = new Headers();
	headers.append("Content-Type", "application/json");
	headers.append("Authorization", "Bearer " + token)

	let method = "POST";

	let reqFilters = [];
	let reqMeasures = [];
	let reqGrouping = [];

	filtersRef.current.forEach((filter) => {
		reqFilters.push({
			field: filter.category,
			operator: "=",
			values: filter.selectedValues,
		});
	});

	reqFilters.push({field: "level", operator: "=", values: [level] });
	reqMeasures.push({name: "measure", formula: "sum(field.direct_cost + field.direct_allocated_cost)"});
	reqGrouping.push("cost_resource_cluster");

	const requestBody = {
		measures: reqMeasures,
		filters: reqFilters,
		grouping: reqGrouping,
		start_date: startDate.format("YYYY-MM-DD"),
		end_date: endDate.format("YYYY-MM-DD"),
		group_by_date: true,
		add_grouped_results: true,
		date_granularity: "month",
	};

	let requestOptions = {
		body: JSON.stringify(requestBody),
		method: method,
		headers: headers,
	};

	const response = await fetch(API_URL + "/get-cloud-cost", requestOptions);

	if (!response.ok) {
		throw new Error("Failed to fetch data");
	}

	return response.json();
}